/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

/**
 * 選択がどの UI から行われたか。一覧マップのエリアラベル層（JCAT-5434）のドット / カードを区別する。
 * TOP の地図版（A/B で廃止）が送っていた `map` / `pin` / `card` / `carousel` は過去データにのみ残る。
 */
export type FeaturedAreaClickSource = 'list_map' | 'list_map_card';

export interface FeaturedAreaClickParams {
  area_group: string;
  destination_tag: string;
  source: FeaturedAreaClickSource;
}

/**
 * 発火タイミング：一覧マップのエリアラベル層で行き先を選択した時。
 *
 * `area_group` は Design Doc の定義どおり**タググループ（地方）の web_path** を送る。
 * 分析側が「三大都市圏外＝tokyo/kyoto-osaka 系以外」を判定するのに使うため、ここに都市タグを
 * 入れると判定が壊れる。選択の実体（都市＝行き先タグ）は `destination_tag` で別に送る。
 *
 * @param areaGroup タググループ web_path（wabunka_tag_groups.web_path）
 * @param destinationTag 選択された行き先タグ web_path（wabunka_tags.web_path）
 * @param source 選択元の UI
 * @see docs/Design Doc/マップ検索 ステージ1・2.md 計測イベント設計（featured_area_click）
 */
export const sendGAWabunkaFeaturedAreaClickEvent = (areaGroup: string, destinationTag: string, source: FeaturedAreaClickSource) => {
  sendWabunkaGAEvent('featured_area_click', { area_group: areaGroup, destination_tag: destinationTag, source } satisfies FeaturedAreaClickParams);
};
